import {
  ApplicationRef,
  Component,
  ComponentFactoryResolver,
  ElementRef,
  EventEmitter,
  Injector,
  Input,
  Output,
  OnDestroy,
  forwardRef,
  OnInit
} from '@angular/core';

import { ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
export const CALENDAR_CONTROL_VALUE_ACCESSOR: any = {
provide: NG_VALUE_ACCESSOR,
useExisting: forwardRef(() => AxisCalendarComponent),
multi: true
};
import * as moment_ from '../utilities/lib-moment/moment-with-locales.custom.min';
const moment = moment_;
import { CalendarComponent } from './calendar.component';
import { CalendarService } from './calendar.shared.service';

@Component({
  host: {
    class: 'axis-calendar-wrapper'
  },
  selector: 'axis-calendar,[axis-calendar]',
  providers: [CALENDAR_CONTROL_VALUE_ACCESSOR],
  template: ''
})
export class AxisCalendarComponent
  implements OnInit, OnDestroy {
  @Input() public dateRange = false;
  @Input() public startDate;
  @Input() public endDate;
  @Input() public datepickerMode = 'day';
  @Input() public browserLocale = false;
  @Output()
  public onSelect: EventEmitter<any> = new EventEmitter();
  @Output()
  public onSelectedRange: EventEmitter<any> = new EventEmitter();
  public selectOnDay = false;
  public selectOnMonth = false;
  public selectOnYear = false;
  public calendarComponentRef: any;
  public modelValue: any;
  public localeLanguage: string;
  public currentDate : any;
  public onChange: any = Function.prototype;
  public onTouched: any = Function.prototype;
  public modelDate;

  constructor(
    private el: ElementRef,
    private resolver: ComponentFactoryResolver,
    private calendarService: CalendarService,
    private injector: Injector,
    private applicationRef: ApplicationRef
  ) { }

  ngOnInit() {
    this.calendarService.setDatepickerInstance(this);
    this.createCalendarComponent();
  }

  createCalendarComponent() {
    if (this.datepickerMode === 'day') {
      this.selectOnDay = true;
    } else {
      this.selectOnDay = false;
    }
    if (this.datepickerMode === 'month') {
      this.selectOnMonth = true;
    } else {
      this.selectOnMonth = false;
    }
    if (this.datepickerMode === 'year') {
      this.selectOnYear = true;
    } else {
      this.selectOnYear = false;
    }
    if (!this.calendarComponentRef) {
      const componentFactory = this.resolver.resolveComponentFactory(
        CalendarComponent
      );
      this.calendarComponentRef = componentFactory.create(this.injector);
      this.applicationRef.attachView(this.calendarComponentRef.hostView);
      this.el.nativeElement.appendChild(this.calendarComponentRef.location.nativeElement);

      this.calendarComponentRef.instance.selectionDone.subscribe(data => {
        this.modelValue = data;
        this.onSelect.emit(this.modelValue);
      });

      this.calendarComponentRef.instance.selectedRange.subscribe(data => {
        this.modelValue = data;
        this.onSelectedRange.emit(this.modelValue);
      });

    }
  }
  public fixTimeZone(date: Date): Date {
    const hours = date.getHours();
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      hours === 23 ? hours + 2 : 0
    );
  }

  writeValue(date) {
    if (date) {
      const value = this.fixTimeZone(date);
      this.predefinedSelection(value);
    }
  }
  // api method for instant selection of calendars
  selectDate(date) { 
    this.predefinedSelection(date);
  }
  predefinedSelection(date) {
    this.modelValue = date;
    this.onSelect.emit(this.modelValue);
    this.calendarComponentRef.instance._calendar.activeDate = date;
    if (!this.dateRange) {
    this.calendarComponentRef.instance._calendar.selectedDate = date;
    }
    if(this.datepickerMode === 'day') {
    this.calendarComponentRef.instance._calendar.refreshViewHandlerDay();
    } else if(this.datepickerMode === 'month') {
      this.calendarComponentRef.instance._calendar.refreshViewHandlerMonth();
    }
  }
// api method for reset selection
  resetSelection(date) {
    this.calendarComponentRef.instance._calendar.activeDate = date;
    this.calendarComponentRef.instance._calendar.startDate = null;
    this.calendarComponentRef.instance._calendar.endDate = null;
    this.calendarComponentRef.instance._calendar.selectedDate = null;
    if (this.datepickerMode === 'day') {
      this.calendarComponentRef.instance._calendar.refreshViewHandlerDay();
    } else if (this.datepickerMode === 'month') {
      this.calendarComponentRef.instance._calendar.refreshViewHandlerMonth();
    }
  }

  // api method for instant selection of calendars
  setSelectionDates(startDate, activeDate, endDate) {
   this.calendarComponentRef.instance._calendar.activeDate = new Date(activeDate);
   this.calendarComponentRef.instance._calendar.startDate = new Date(startDate);
   this.calendarComponentRef.instance._calendar.endDate = new Date(endDate);
   this.calendarComponentRef.instance._calendar.focusedDate = new Date(activeDate);
   if(this.datepickerMode === 'day') {
    this.calendarComponentRef.instance._calendar.refreshViewHandlerDay();
    } else if(this.datepickerMode === 'month') {
      this.calendarComponentRef.instance._calendar.refreshViewHandlerMonth();
    }
  }
// api method to move directions of calendars
  moveDirection(number) {
    this.calendarComponentRef.instance._calendar.move(number);
    if(this.datepickerMode === 'day') {
      this.calendarComponentRef.instance._calendar.refreshViewHandlerDay();
      } else if(this.datepickerMode === 'month') {
        this.calendarComponentRef.instance._calendar.refreshViewHandlerMonth();
      }
  }

  // api method for on selection of calendar date
  selectedRangeDate(startDate, endDate) {
    this.calendarComponentRef.instance._calendar.selectedDate = startDate;
    this.calendarComponentRef.instance._calendar.startDate = startDate;
    this.calendarComponentRef.instance._calendar.endDate = endDate;
    if (this.datepickerMode === 'day') {
      this.calendarComponentRef.instance._calendar.refreshViewHandlerDay();
    } else if (this.datepickerMode === 'month') {
      this.calendarComponentRef.instance._calendar.refreshViewHandlerMonth();
    }
  }


  registerOnChange(fn: (_: any) => {}): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }
 
  ngOnDestroy() {
    if (this.calendarComponentRef) {
      this.calendarComponentRef.destroy();
    }
  }
}




